import React, { useRef, useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa6";

const specifications = [
  {
    title: "Vodoodpornost",
    description:
      "Črpalka je vodoodporna ob izdelavi in ob pravilni vstavitvi rezervoarja ter infuzijskega seta. Zaščitena je pred vplivi vode do globine 2,4 metra za največ 30 minut. ",
  },
  {
    title: "Okoljski pogoji",
    description:
      "Sistem inzulinske črpalke MiniMed™ 780G je zasnovan tako, da prenese večino pogojev, s katerimi se srečujete v vsakdanjem življenju. Temperaturno območje za shranjevanje črpalke je od -20 °C do 50 °C. Razpon zračnega tlaka je od 700 hPa do 1060 hPa. ",
  },
  {
    title: "Nadmorska višina",
    description: "Območje za delovanje črpalke je od 10.2 psiA (70.33 kPa) do 15.4 psiA (106.18 kPa), območje shranjevanja pa od 7.2 psiA (49.64 kPa) to 15.4 psiA (106.18 kPa)",
  },
  {
    title: "Vrsta inzulina",
    description:
      "Trenutno je črpalka MiniMed™ 780G s programsko opremo 6.23 združljiva s kratko delujočimi inzulini (NovoRapid in Humalog) ter ultra kratko delujočimi inzulini (Fiasp in Lyumjev).",
  },

  {
    title: "Dovajanje bolusa",
    description: (
      <div>
        <div>Hitrost dovajanja bolusov</div>
        <ul className="py-3 list-disc list-outside px-5">
          <li className="py-3">Standardno : 1.5 enot/minuto</li>
          <li className="py-3">Hitro : 15 enot/minuto</li>
        </ul>
        <div> Programiranje v korakih </div>
        <ul className="py-3 list-disc list-outside px-5">
          <li className="py-3">0.025 enote</li>
          <li className="py-3">0.05 enote</li>
          <li className="py-3">0.1 enote</li>
          <li className="py-3">0.25 enote</li>
        </ul>
        <div>Maksimalni bolus: 25 enot</div>
      </div>
    ),
  },
  {
    title: "Bazalno dovajanje",
    description: "0 do 35 enot na uro",
  },
  {
    title: "Zaslon",
    description: (
      <div>
        <ul className="list-disc list-outside px-5">
          <li className="py-3">Barvni zaslon s samodejno nastavitvijo svetlosti.</li>
          <li className="py-3">
          Čas osvetlitve ozadja: 15 sekund (privzeto), 30 sekund, 1 minuta, 3 minute.
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: "Baterija in napajanje",
    description:
      "Črpalka deluje z eno novo AA (1,5 V) baterijo. Za najboljše rezultate uporabite novo litijevo AA baterijo (FR6). Črpalka podpira tudi alkalno AA baterijo (LR6) ali polno napolnjeno NiMH AA baterijo (HR6).",
  },
  {
    title: "Spomin črpalke",
    description: "Kadarkoli lahko pregledate 35 dni zgodovine črpalke.",
  },
  {
    title: "Velikost",
    description: (
      <div>
        <div>Velikost: PRIME: 5.4 cm x 9.7 cm x 2.5 cm</div>
        <div>Teža: PRIME: &lt;106 gramov (brez potrošnega materiala in baterije)</div>
      </div>
    ),
  },
  {
    title: "Garancija",
    description: "Izulinska črpalka: 4 leta",
  },
];

const compatibelProducts = [
  {
    title: "Rezervoar",
    description:
      "Rezervoar Medtronic Extended MMT-342, 10PK. 3.0 mL (300 enot)",
  },
  {
    title: "Infuzijski set",
    description: (
      <div>
        Medtronic Diabetes ponuja širok nabor infuzijskih setov, izmed katerih lahko izberete primernega za lastno udobje in varnost.{" "}
        <a className="text-blue-600 hover:underline" href="https://www.zaloker-zaloker.si/wp-content/uploads/infuzijski-seti-in-rezervoarji-medtronic.pdf">
          https://www.zaloker-zaloker.si/wp-content/uploads/infuzijski-seti-in-rezervoarji-medtronic.pdf
        </a>
      </div>
    ),
  },
  {
    title: "Senzor in oddajnik Guardian™ Link 4",
    description:
      "Uporablja se skupaj s črpalko, za neprekinjeno spremljanje glukoze. Naprava se povezuje z glukoznim senzorjem, oddajnik pa zbrane podatke brezžično pošilja v inzulinsko črpalko.",
  },
  {
    title: "Senzor Simplera Sync",
    description:
      "Uporablja se s črpalko in je namenjen neprekinjenemu merjenju glukoze. Ne zahteva meritve glukoze v krvi za umerjanje ali sprejemanje odločitev o zdravljenju sladkorne bolezni*. Glukozo meri vsakih 5 minut, kar pomeni 288 meritev dnevno, ter vam in vaši črpalki zagotavlja informacije o trenutni ravni glukoze in smeri njenega gibanja. Te podatke lahko črpalka uporabi tudi za opozarjanje na morebitno povišano ali znižano raven glukoze.",
  },

  {
    title: "Dodatki",
    description: (
      <div>
        Vašo inzulinsko črpalko lahko nosite na več načinov. Črpalko lahko pritrdite na pas ali pasno zaponko, jo zaščitite v žepu ali jo pripnete pod oblačila. Oglejte si dodatke tukaj:{" "}
        <a className="text-blue-600 hover:underline" href="https://www.zaloker-zaloker.si/kategorija-izdelka/dodatki-za-inzulinsko-crpalko/">
          https://www.zaloker-zaloker.si/kategorija-izdelka/dodatki-za-inzulinsko-crpalko/
        </a>
      </div>
    ),
  },
  {
    title: "Merilnik glukoze v krvi Accu-Chek® Guide Link ",
    description: (
      <div>
        Sistem MiniMed™ 780G vključuje skladni merilnik. Ta se brezžično poveže z vašo črpalko in omogoča pošiljanje odčitkov merilnika glukoze v krvi neposredno v črpalko<sup>~</sup>.
      </div>
    ),
  },
];

const TechnicalSkills = () => {
  const [open, setOpen] = useState(false);
  const contentRef = useRef(null);

  const toggleAccordion = () => {
    setOpen(!open);
  };
  return (
    <>
      <section className="py-8 px-4 lg:px-28">
        <div className="py-7 border-b border-gray-200 group">
          <div className="py-2 ">
            {/* Accordion Header */}
            <button
              className="w-full flex justify-between items-center text-left focus:outline-none"
              onClick={toggleAccordion}
            >
              <h2 className="my-5 text-2xl md:text-4xl font-light md:leading-[4.5rem]">
                Tehnične specifikacije
              </h2>
              <div className="pr-5 mt-0.5 ml-2 text-gray-800 text-lg group-hover:text-gray-800">
                {open ? (
                  <div className="bg-red-500 rounded-full h-8 w-8 flex items-center justify-center">
                    <FaMinus className="text-white" />
                  </div>
                ) : (
                  <div className="bg-red-500 rounded-full h-8 w-8 flex items-center justify-center">
                    <FaPlus className="text-white" />
                  </div>
                )}
              </div>
            </button>

            {/* Accordion Content */}
            <div
              className={`transition-all duration-700 ease-in-out overflow-hidden`}
              style={{
                maxHeight: open
                  ? `${contentRef.current?.scrollHeight}px`
                  : "0px",
              }}
              ref={contentRef}
            >
              <div className="p-2">
                {specifications.map((spec, index) => (
                  <div
                    key={index}
                    className={`grid grid-cols-10 py-5 px-3 mb-6 ${
                      index % 2 !== 0 ? "bg-gray-50 " : ""
                    }`}
                  >
                    <h2 className="pr-5 col-span-10 md:col-span-2 lg:col-span-2 text-lg font-light text-gray-800 mb-2">
                      {spec.title}
                    </h2>
                    <div className="col-span-10 md:col-span-8 lg:col-span-8 text-gray-600">
                      {spec.description}
                    </div>
                  </div>
                ))}
              </div>
              <h2 className="bg-gray-50 w-full text-center p-10 ">
              Pripadajoč potrošni material
              </h2>
              <div className="p-2">
                {compatibelProducts.map((spec, index) => (
                  <div
                    key={index}
                    className={`grid grid-cols-10 py-5 px-3 mb-6 ${
                      index % 2 !== 0 ? "bg-gray-50 " : ""
                    }`}
                  >
                    <h2 className="pr-5 col-span-10 md:col-span-2 lg:col-span-2 text-lg font-light text-gray-800 mb-2">
                      {spec.title}
                    </h2>
                    <div className="col-span-10 md:col-span-8 lg:col-span-8 text-gray-600">
                      {spec.description}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TechnicalSkills;
